import { render } from "./WhatAutoComplete.component.vue?vue&type=template&id=b9964a4a"
import script from "./WhatAutoComplete.component.vue?vue&type=script&lang=js"
export * from "./WhatAutoComplete.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/homePage/autoCompleteComponents/WhatAutoComplete.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9964a4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9964a4a', __exports__)) {
    console.log('reload')
    api.reload('b9964a4a', __exports__)
  }
  
  module.hot.accept("./WhatAutoComplete.component.vue?vue&type=template&id=b9964a4a", () => {
    console.log('re-render')
    api.rerender('b9964a4a', render)
  })

}


export default __exports__